module.exports = __webpack_public_path__ + "static/media/img_10-1.516c169d.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/v2/img_10-1.png
// module id = 700
// module chunks = 0